import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TableHeader from '../../atoms/table/TableHeader';
import TableHeaderCell from '../../atoms/table/TableHeaderCell';
const InvoiceTableHeader = () => {
    return (_jsxs(TableHeader, { children: [_jsx(TableHeaderCell, { children: "Factuurnr." }), _jsx(TableHeaderCell, { children: "Datum" }), _jsx(TableHeaderCell, { children: "Vervaldatum" }), _jsx(TableHeaderCell, { children: "Omschrijving" }), _jsx(TableHeaderCell, { children: "Bedrag" })] }));
};
export default InvoiceTableHeader;
